import { mdiPlaneTrain, mdiHome, mdiFlowerTulip, mdiHelpCircle, mdiBasketOutline } from '@mdi/js';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ubpznnyeewqjgrpzhnqv.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVicHpubnllZXdxamdycHpobnF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg4NjE3MTIsImV4cCI6MjA2NDQzNzcxMn0.xqOGKv6ycW16buUvXGq-s-BSbQl-29GUn0VVS0cNVi8';

//-------------------------------------------------------------------------
// SUPABASE
//-------------------------------------------------------------------------
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * récupération du UserId de supabase
 * @returns {Promise<string | null>} UserId de supabase
 */
export async function getUserIdSupabase(): Promise<string | null> {
  try{
    console.log("-- Debut getUserIdSupabase --");

    console.log("Débutsupabase.auth.getUser");
    const { data, error } = await supabase.auth.getUser();
    console.log("Fin supabase.auth.getUser");

    if (error) {
      console.error("Erreur récupération utilisateur Supabase :", error.message);
      return null;
    }

    const user = data.user;
    
    if (!user) {
      console.warn("Aucun utilisateur connecté");
      return null;
    }
    console.log("userIdSupabase = ",user.id);

    console.log("-- Fin getUserIdSupabase --");
    return user.id; // ou user.email, user.app_metadata, etc.
  }catch(e){
      console.error("Erreur globale getUserIdSupabase : ", e);
      return null;
  }
}


//-------------------------------------------------------------------------
// TYPE
//-------------------------------------------------------------------------
export type TypeItem = { id: number; icon: string; label: string };
const types: TypeItem[] = [
  { id: 1, icon: mdiPlaneTrain, label: 'Voyage' },
  { id: 2, icon: mdiHome, label: 'Maison' },
  { id: 3, icon: mdiFlowerTulip, label: 'Plantes' },
  { id: 4, icon: mdiBasketOutline, label: 'Course' }
];

export function GetTypes()
{
  return types;
}
export function GetTypeFromNumber(id: number) {
  return types.find(type => type.id === id) || { id: 99, icon: mdiHelpCircle, label: 'Inconnue' };
}
//-------------------------------------------------------------------------
// ETAT
//-------------------------------------------------------------------------
export function getEtatTexte(etat: number) {
  switch(etat) {
    case 1: return 'A faire';
    case 2: return 'En cours';
    case 3: return 'Terminé';
    default: return 'ERREUR - valeur non définie dans getEtatTexte';
  }
}

//-------------------------------------------------------------------------
// PROJET
//-------------------------------------------------------------------------
/**
 * Interface vers la table Projet
**/
export interface Projet {
  id?: number // optionnel car généré par la DB à l’insertion
  Nom: string
  DeadLine: string | Date
  IdProjetParent?: number | null
  Etat: number
  Type : number
}

/**
 * Interface vers la vue vue_projet_utilisateur
**/
export interface VueProjetUtilisateur {
  ProjetId: number
  ProjetNom: string
  ProjetDeadline: string | Date
  ProjetEtat: number
  IdUtilisateurDunProjet: number | null
  UtilisateurUid: string | null
  ProjetType: number
}

/**
 * Crée un projet via la Edge Function sécurisée 'create_projet_with_user'
 * (insertion transactionnelle + association utilisateur)
 *
 * @param projet - Données du projet à créer
 * @param idUtilisateur - id du créateur (user Supabase)
 * @returns Résultat de la fonction Edge
 */
export async function createProjetWithUserEdge(projet: Omit<Projet, 'id'>, uidSupabase: string): Promise<any> {
  console.log("-- Début createProjetWithUserEdge --");
  
  console.log("Début supabase.auth.getSession");
  const session = (await supabase.auth.getSession()).data.session;
  console.log("Fin supabase.auth.getSession");

  if (!session || !session.access_token) {
    throw new Error('Utilisateur non authentifié ou session invalide');
  }
  
  console.log("Début getUtilisateurIdFromUid avec udi = ", uidSupabase);
  const idUtilisateur = await getUtilisateurIdFromUid(uidSupabase);
  console.log("Fin getUtilisateurIdFromUid avec udi = ", uidSupabase);
  if(!idUtilisateur){
    console.error("erreur lors de la récupration de supabase.Utilisateurs.id depuis le uid")
    throw new Error('erreur lors de la récupration de supabase.Utilisateurs.id depuis le uid');
  }
  console.log("idUtilisateur = ", idUtilisateur);

  const { Nom, DeadLine, IdProjetParent = null, Etat, Type } = projet;
  const deadLineFormatted = DeadLine instanceof Date ? DeadLine.toISOString().split('T')[0] : DeadLine;

  const payload = {
  Nom: Nom,
  DeadLine: deadLineFormatted,
  IdProjetParent: IdProjetParent,
  Etat: Etat,
  IdUtilisateur: idUtilisateur,
  TypeProjet: Type,
};

  console.log("Payload =", payload);
  console.log("Token = ", session.access_token);

  console.log("Début appel supabase.functions.invoke('create_projet_with_user')");
  
  const response = await fetch('https://ubpznnyeewqjgrpzhnqv.supabase.co/functions/v1/create_projet_with_user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`
    },
    body: JSON.stringify(payload)
  });
  
  console.log("Status HTTP:", response.status);
  
  if (!response.ok) {
    const errBody = await response.text();
    console.error("Erreur réponse fonction Edge:", errBody);
    throw new Error(`Erreur HTTP ${response.status} : ${errBody}`);
  }
  
  const data = await response.json();
  

  console.log("Fin appel supabase.functions.invoke('create_projet_with_user')");
  
  console.log("Réponse =", data);

  console.log("-- Fin createProjetWithUserEdge --");
  return data;
}

/**
 * Récupére les projets de l'utilisateur connecté dont IdProjetParent=null
 *
 * @returns les des projets de l'utilisateur dont IdProjetParent=null
 */
export async function getMainProjets(uidSupabase: string): Promise<VueProjetUtilisateur[]> {
  try
  {
    console.log("-- Début getMainProjets --");
    console.log("Début supabase.auth.getSession");
    const session = (await supabase.auth.getSession()).data.session;
    console.log("Fin supabase.auth.getSession");

    if (!session || !session.access_token) {
      throw new Error('Utilisateur non authentifié ou session invalide');
    }

    console.log('Début du select sur vue_projet_utilisateur');
    const { data: resultatVue, error } = await supabase
      .from('vue_projet_utilisateur')
      .select('ProjetId,ProjetNom,ProjetDeadline,ProjetEtat, IdUtilisateurDunProjet, UtilisateurUid, ProjetType')
      .eq('UtilisateurUid', uidSupabase);
    console.log('Fin du select sur vue_projet_utilisateur');

    console.log(resultatVue);

    if (error || !resultatVue) {
      throw new Error(error.message);
    }

    console.log("-- Fin getUtilisateurIdFromUid --");
    return resultatVue;
  } catch (error) {
    console.error('Erreur dans getMainProjets :', error)
    return [];
  }
}

//-------------------------------------------------------------------------
// UTILISATEURS
//-------------------------------------------------------------------------
export interface Utilisateur {
  id: number;
  Nom: string;
  Prenom: string;
  Mail: string;
  IdApplication: number | null;
  uId: string; // UUID en string
}

export async function getUtilisateurIdFromUid(uidSupabase: string)
{
  try
  {
    console.log("-- Début getUtilisateurIdFromUid --");
    console.log("Début supabase.auth.getSession");
    const session = (await supabase.auth.getSession()).data.session;
    console.log("Fin supabase.auth.getSession");

    if (!session || !session.access_token) {
      throw new Error('Utilisateur non authentifié ou session invalide');
    }

    console.log('Début du select sur Utilisateur');
    const { data: utilisateur, error } = await supabase
      .from('Utilisateurs')
      .select('id')
      .eq('uId', uidSupabase)
      .single();
    console.log('Fin du select sur Utilisateur');

    if (error || !utilisateur) {
      throw new Error(error.message);
    }
    const idutilisateur = utilisateur.id;
    console.log('idutilisateur=', idutilisateur);

    console.log("-- Fin getUtilisateurIdFromUid --");
    return utilisateur.id;
  } catch (error) {
    console.error('Erreur dans getUtilisateurIdFromUid :', error)
  }
}

/**
 * Renvoi les utilisateurs amis d'un utilisateur 
 * @param uidSupabase l'utilisateur connecter /!\ uuid supabase pas l'id de la table Utilisateurs/!\ 
 * @returns la liste des utilisateurs "amis" ==> Pas traité à ce jour. Cela renvoi tous les utilisateurs => A ADAPTER
 */
export async function getMyFriends(uidSupabase: string): Promise<Utilisateur[]>{
  try {
    console.log("-- Début getMyFriends --");

    const session = (await supabase.auth.getSession()).data.session;
    if (!session || !session.access_token) {
      throw new Error('Utilisateur non authentifié ou session invalide');
    }

    console.log('Début du select sur Utilisateurs');
    const { data: utilisateurs, error } = await supabase
      .from('Utilisateurs')
      .select('id, Nom, Prenom, Mail, IdApplication, uId');  // Tous les champs

    if (error) {
      throw new Error(error.message);
    }

    console.log('Fin du select sur Utilisateurs');
    console.log('Nombre d’utilisateurs récupérés:', utilisateurs.length);

    console.log("-- Fin getMyFriends --");
    return utilisateurs;
  } catch (error) {
    console.error('Erreur dans getMyFriends :', error);
    return [];
  }
}
